'use client';

import { GridItem } from '@jouzen/ecom-components/v3/GridItem';
import { LayoutGrid } from '@jouzen/ecom-components/v3/LayoutGrid';
import { Typography } from '@jouzen/ecom-components/v3/Typography';
import Link from 'next/link';
import { useLocale, useTranslations } from 'next-intl';

const Content = () => {
  const selectedLocale = useLocale();
  const t = useTranslations();

  return (
    <LayoutGrid data-cy="fcc-compliance-statements">
      <GridItem colEnd={{ sm: 'main' }} colStart={{ sm: 'main' }}>
        <Typography Element="h1" variant="h3" className="mb-4">
          {t('fcc_sdoc_index_title')}
        </Typography>
        <Typography variant="h6" className="mb-8">
          {t('fcc_sdoc_index_copy')}
        </Typography>
        <Typography className="mb-4 underline">
          <Link href={`/${selectedLocale}/fcc-compliance-statements/oa11`}>
            {t('fcc_sdoc_nav_header')} (OA11)
          </Link>
        </Typography>
        <Typography className="mb-10 underline">
          <Link href={`/${selectedLocale}/fcc-compliance-statements/oa12`}>
            {t('fcc_sdoc_nav_header')} (OA12)
          </Link>
        </Typography>
      </GridItem>
    </LayoutGrid>
  );
};

export default Content;
